export default "__VITE_ASSET__CjCfq77G__"